// Admin Settings Page translations
export const adminSettingsTranslations = {
    en: {
        // Page header
        storeSettings: "Store Settings",
        configureStorePreferences: "Configure your store preferences",

        // Common actions
        save: "Save",
        saveSettings: "Save Settings",
        saving: "Saving...",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        remove: "Remove",
        close: "Close",
        yes: "Yes",
        no: "No",

        // Authentication messages
        initializingAuthentication: "Initializing authentication...",
        accessDenied: "Access Denied",
        mustBeLoggedInAsStoreOwner: "You must be logged in as a store owner to access this page.",
        loadingStoreSettings: "Loading store settings...",

        // Success/Error messages
        storeSettingsSavedSuccessfully: "Store settings saved successfully",
        failedToLoadStoreSettings: "Failed to load store settings: {message}. Please try refreshing the page.",
        failedToSaveSettings: "Failed to save settings: {message}. Please try again.",
        storeNameInEnglishRequired: "Store name in English is required",
        shippingSettingsSaved: "Shipping settings saved successfully",
        countrySettingsSaved: "Country settings saved successfully",
        taxSettingsSaved: "Tax settings saved successfully",
        saveShippingSettings: "Save Shipping Settings",
        saveCountrySettings: "Save Country Settings",
        saveTaxSettings: "Save Tax Settings",

        // Tab names
        general: "General",
        homePage: "Home Page",
        shipping: "Shipping",
        payment: "Payment",
        promoCodes: "Promo Codes",
        announcements: "Announcements",
        tax: "Tax",
        countries: "Countries",
        socialMedia: "Social Media",
        emailConfig: "Email Configuration",

        // General Tab
        storeInformation: "Store Information",
        storeName: "Store Name",
        storeNamePlaceholder: "Enter your store name",
        storeDescription: "Store Description",
        storeDescriptionPlaceholder: "Describe your store",
        contactInformation: "Contact Information",
        emailAddress: "Email Address",
        emailPlaceholder: "store@example.com",
        phoneNumber: "Phone Number",
        phonePlaceholder: "+971 50 123 4567",
        address: "Address",
        addressPlaceholder: "Your store address",
        customDomain: "Custom Domain",
        customDomainPlaceholder: "https://yourdomain.com or subdomain.raffak.store",
        currency: "Currency",
        selectCurrency: "Select currency",
        storeLogo: "Store Logo",
        uploadLogo: "Upload Logo",
        currentLogo: "Current Logo",
        noLogoUploaded: "No logo uploaded",

        // Brand Colors
        brandColors: "Brand Colors",
        brandColorsDescription: "Customize your store's color scheme. These colors will be applied across your entire website.",
        primaryColor: "Primary Color",
        primaryColorHelp: "Main theme color used for buttons, links, and accents",
        hoverColor: "Hover Color",
        hoverColorHelp: "Color shown when hovering over interactive elements",
        textColor: "Text Color",
        textColorHelp: "Primary text color for headings and content",
        lightColor: "Light Background Color",
        lightColorHelp: "Soft background color for sections and cards",

        // Shipping Tab
        shippingSettings: "Shipping Settings",
        shippingRequirement: "Shipping & Delivery",
        requiresShipping: "This store requires shipping/delivery for products",
        requiresShippingHelp: "Uncheck this if you sell digital products, courses, or services that don't require physical delivery. When disabled, customers won't need to provide shipping addresses.",
        editShippingOptionsIn: "Edit Shipping Options In:",
        shippingOptions: "Shipping Options",
        addShippingOption: "Add Shipping Option",
        shippingMethodName: "Shipping Method Name",
        cost: "Cost",
        deliveryTime: "Delivery Time",
        freeDeliverySettings: "Free Delivery Settings",
        enableFreeDelivery: "Enable Free Delivery",
        minimumSpendForFreeDelivery: "Minimum Spend for Free Delivery",
        noShippingOptionsAdded: "No shipping options added yet",

        // Payment Tab
        paymentSettings: "Payment Settings",
        acceptedPaymentMethods: "Accepted Payment Methods",
        creditCard: "Credit Card",
        paypal: "PayPal",
        applePay: "Apple Pay",
        cashOnDelivery: "Cash on Delivery",
        manualTransfer: "Manual Bank Transfer",
        bankTransferDetails: "Bank Transfer Details",
        bankTransferDetailsNote: "Paste your bank details here. This information will be shown to customers who select manual transfer payment.",
        bankDetailsEnglish: "Bank Details (English)",
        bankDetailsArabic: "Bank Details (Arabic)",
        savePaymentMethods: "Save Payment Methods",
        paymentMethodsSaved: "Payment methods saved successfully!",
        failedToSavePaymentMethods: "Failed to save payment methods",

        // Tax Tab
        taxSettings: "Tax Settings",
        taxRate: "Tax Rate (%)",
        taxIncluded: "Tax Included in Prices",
        taxExcluded: "Tax Excluded from Prices",

        // Countries Tab
        countrySettings: "Country Settings",
        availableCountries: "Available Countries",
        addCountry: "Add Country",
        countryCode: "Country Code",
        countryName: "Country Name",
        noCountriesAdded: "No countries added yet",
        viewCountriesIn: "View Countries in:",
        countriesDescription: "Select countries where you want to ship your products. These countries will be available for customers during checkout.",
        selectCountry: "Select a country...",

        // Social Media Tab
        socialMediaSettings: "Social Media Settings",
        socialMediaLinks: "Social Media Links",
        facebookUrl: "Facebook URL",
        instagramUrl: "Instagram URL",
        twitterUrl: "Twitter URL",
        tiktokUrl: "TikTok URL",

        // Email Configuration Tab
        emailConfiguration: "Email Configuration",
        emailConfigDescription: "Configure SMTP settings for sending order confirmations, password resets, and notifications.",
        configured: "Configured",
        usingDefaultConfig: "Using default email configuration; noreply@raffak.store",
        source: "Source",
        emailFrom: "Email Address (From)",
        emailFromHelp: "This email address will appear as the sender for all store emails",
        emailPassword: "Email Password / App Password",
        emailPasswordHelp: "Your email account password or app-specific password",
        smtpHost: "SMTP Host",
        smtpHostHelp: "Common: smtp.hostinger.com, smtp.gmail.com, smtp.office365.com",
        smtpPort: "SMTP Port",
        smtpPortHelp: "Common: 587 (TLS), 465 (SSL), 25 (unsecured)",
        useSSL: "Use SSL/TLS (Port 465)",
        useSSLHelp: "Enable this if using port 465. Disable for port 587 (STARTTLS)",
        saveEmailConfig: "Save Email Configuration",
        testEmailConfig: "Test Email Configuration",
        testEmailDescription: "Send a test email to verify your configuration is working correctly",
        testEmailAddress: "Test Email Address",
        enterTestEmailPlaceholder: "Leave empty to send to your account email",
        sendTestEmail: "Send Test Email",
        sendingTest: "Sending...",
        testEmailSent: "Test email sent successfully!",
        commonProviders: "Common SMTP Providers",
        failedToLoadEmailConfig: "Failed to load email configuration",
        emailFromAndPasswordRequired: "Email and password are required",
        emailConfigSaved: "Email configuration saved successfully!",
        failedToSaveEmailConfig: "Failed to save email configuration",
        enterTestEmail: "Please enter a test email address",
        failedToSendTestEmail: "Failed to send test email",

        // Stripe Configuration
        stripeConfiguration: "Stripe Configuration",
        stripePublishableKey: "Publishable Key",
        stripePublishableKeyHint: "Public key that starts with pk_",
        stripeSecretKey: "Secret Key",
        stripeSecretKeyHint: "Secret key that starts with sk_ (will be encrypted)",
        stripeKeysRequired: "Publishable and secret keys are required",
        stripeConfigSaved: "Stripe configuration saved successfully!",
        failedToSaveStripeConfig: "Failed to save Stripe configuration",
        testStripeConfig: "Test Configuration",
        failedToTestStripeConfig: "Failed to test Stripe configuration",
        saveStripeConfig: "Save Stripe Configuration",
        testing: "Testing...",
        stripeConfiguredInDatabase: "Stripe is configured in database",
        stripeUsingEnvironment: "Using environment variables (consider setting up in database)",
        whereToFindKeys: "Where to find your Stripe keys:",
        stripeStep1: "Go to Stripe Dashboard",
        stripeStep2: "Search for 'API key' in the search bar",
        stripeStep3: "The public key will be visible starting with pk_live_",
        stripeStep4: "Click 'Create a new secret key'",
        stripeStep5: "Select the second option: 'Build your own integration'",
        stripeStep6: "Complete the verification setup",
        stripeStep7: "You will get a secret key starting with sk_live_",
        stripeSecurityNote: "Your secret key is encrypted before storage for security",
        failedToLoadStripeConfig: "Failed to load Stripe configuration",
        loading: "Loading...",

        // Promo Codes Tab
        promoCodeSettings: "Promo Code Settings",
        enablePromoCodes: "Enable Promo Codes",
        managePromoCodes: "Manage Promo Codes",
        promoCodesDescription: "Create and manage discount codes for your customers",
        createNewPromoCode: "Create New Promo Code",
        editPromoCode: "Edit Promo Code",
        promoCode: "Promo Code",
        promoCodePlaceholder: "e.g., SAVE20",
        description: "Description",
        descriptionPlaceholder: "Internal description for this promo code",
        discountType: "Discount Type",
        percentage: "Percentage",
        fixedAmount: "Fixed Amount",
        discountValue: "Discount Value",
        minimumOrderAmount: "Minimum Order Amount (Optional)",
        maximumDiscountAmount: "Maximum Discount Amount (Optional)",
        usageLimit: "Usage Limit (Optional)",
        unlimited: "Unlimited",
        validFrom: "Valid From",
        validUntil: "Valid Until (Optional)",
        noExpiry: "No expiry",
        isActive: "Is Active",
        activePromoCode: "Active promo code",
        firstTimeOnly: "First Time Customers Only",
        firstTimeOnlyDescription: "Only customers who have never placed an order can use this code",
        applicableProducts: "Applicable Products (Optional)",
        applicableCategories: "Applicable Categories (Optional)",
        loadingPromoCodes: "Loading promo codes...",
        noPromoCodesFound: "No promo codes found",
        createFirstPromoCode: "Create your first promo code to start offering discounts to customers",
        code: "Code",
        type: "Type",
        value: "Value",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        created: "Created",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        activate: "Activate",
        deactivate: "Deactivate",
        promoCodeRequired: "Promo code is required",
        discountValueMustBeGreaterThanZero: "Discount value must be greater than 0",
        promoCodeUpdatedSuccessfully: "Promo code updated successfully",
        promoCodeCreatedSuccessfully: "Promo code created successfully",
        failedToSavePromoCode: "Failed to save promo code",
        promoCodeDeletedSuccessfully: "Promo code deleted successfully",
        failedToDeletePromoCode: "Failed to delete promo code",
        failedToUpdatePromoCodeStatus: "Failed to update promo code status",
        activated: "activated",
        deactivated: "deactivated",
        promoCodeStatusUpdated: "Promo code {status} successfully",

        // Announcements Tab
        announcementSettings: "Announcement Settings",
        manageAnnouncements: "Manage Announcements",

        // Home Page Tab
        homePageSettings: "Home Page Settings",
        manageHomePageContent: "Manage Home Page Content",
        homePageContent: "Home Page Content",
        customizeHomePageDescription: "Customize what your customers see on your store's home page",
        editContentIn: "Edit Content in:",
        loadingHomePageContent: "Loading home page content...",
        heroSection: "Hero Section",
        heroSectionDescription: "This appears at the top of your home page as a large banner with text overlay. It's the first thing customers see when they visit your store.",
        mainTitle: "Main Title",
        subtitle: "Subtitle",
        mainTitlePlaceholder: "e.g., Handmade by Emirati Hands",
        subtitlePlaceholder: "e.g., Crafted with love, just for you.",
        displayedAsLargeHeading: "Displayed as a large heading on your hero banner",
        appearsUnderMainTitle: "Appears under your main title",
        heroMediaUpload: "Hero Media Upload",
        heroMediaDescription: "Choose a stunning image or video for your hero section background",
        currentMedia: "Current Media",
        uploadNewMedia: "Upload New Media",
        removeMedia: "Remove Media",
        removeMediaTitle: "Remove media",
        heroPreview: "Hero preview",
        supportedFormats: "Supported formats: JPG, PNG, GIF, MP4, WebM (Max 10MB)",
        overlayOpacity: "Overlay Opacity",
        overlayOpacityDescription: "Adjust background dimming to make text more readable",
        storySection: "Story Section",
        storySectionDescription: "Tell your brand's story and connect with customers on a personal level",
        storyTitle: "Story Title",
        storyDescription: "Story Description",
        storyTitlePlaceholder: "e.g., Our Story",
        storyDescriptionPlaceholder: "Share your brand's journey, values, or mission...",
        saveHomePageContent: "Save Home Page Content",
        failedToLoadHomePageContent: "Failed to load home page content",
        selectValidImageOrVideo: "Please select a valid image or video file",
        confirmRemoveMedia: "Are you sure you want to remove the current media? This will be saved when you click \"Save Home Page Content\".",
        storeIdRequired: "Store ID is required",

        // Language labels
        english: "English",
        arabic: "Arabic",

        // Form validation
        thisFieldIsRequired: "This field is required",
        invalidEmailFormat: "Invalid email format",
        invalidUrlFormat: "Invalid URL format",

        // Common labels
        name: "Name",
        description: "Description",
        url: "URL",
        enabled: "Enabled",
        disabled: "Disabled",
        active: "Active",
        inactive: "Inactive"
    },
    ar: {
        // Page header
        storeSettings: "إعدادات المتجر",
        configureStorePreferences: "تكوين تفضيلات متجرك",

        // Common actions
        save: "حفظ",
        saveSettings: "حفظ الإعدادات",
        saving: "جارٍ الحفظ...",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل",
        add: "إضافة",
        remove: "إزالة",
        close: "إغلاق",
        yes: "نعم",
        no: "لا",

        // Authentication messages
        initializingAuthentication: "جارٍ تهيئة المصادقة...",
        accessDenied: "تم رفض الوصول",
        mustBeLoggedInAsStoreOwner: "يجب أن تكون مسجل الدخول كمالك متجر للوصول إلى هذه الصفحة.",
        loadingStoreSettings: "جارٍ تحميل إعدادات المتجر...",

        // Success/Error messages
        storeSettingsSavedSuccessfully: "تم حفظ إعدادات المتجر بنجاح",
        failedToLoadStoreSettings: "فشل في تحميل إعدادات المتجر: {message}. يرجى إعادة تحديث الصفحة.",
        failedToSaveSettings: "فشل في حفظ الإعدادات: {message}. يرجى المحاولة مرة أخرى.",
        storeNameInEnglishRequired: "اسم المتجر باللغة الإنجليزية مطلوب",
        shippingSettingsSaved: "تم حفظ إعدادات الشحن بنجاح",
        countrySettingsSaved: "تم حفظ إعدادات البلدان بنجاح",
        taxSettingsSaved: "تم حفظ إعدادات الضريبة بنجاح",
        saveShippingSettings: "حفظ إعدادات الشحن",
        saveCountrySettings: "حفظ إعدادات البلدان",
        saveTaxSettings: "حفظ إعدادات الضريبة",

        // Tab names
        general: "عام",
        homePage: "الصفحة الرئيسية",
        shipping: "الشحن",
        payment: "الدفع",
        promoCodes: "أكواد الخصم",
        announcements: "الإعلانات",
        tax: "الضريبة",
        countries: "البلدان",
        socialMedia: "وسائل التواصل الاجتماعي",
        emailConfig: "إعدادات البريد الإلكتروني",

        // General Tab
        storeInformation: "معلومات المتجر",
        storeName: "اسم المتجر",
        storeNamePlaceholder: "أدخل اسم متجرك",
        storeDescription: "وصف المتجر",
        storeDescriptionPlaceholder: "صف متجرك",
        contactInformation: "معلومات الاتصال",
        emailAddress: "عنوان البريد الإلكتروني",
        emailPlaceholder: "store@example.com",
        phoneNumber: "رقم الهاتف",
        phonePlaceholder: "+971 50 123 4567",
        address: "العنوان",
        addressPlaceholder: "عنوان متجرك",
        customDomain: "النطاق المخصص",
        customDomainPlaceholder: "https://yourdomain.com أو subdomain.raffak.store",
        currency: "العملة",
        selectCurrency: "اختر العملة",
        storeLogo: "شعار المتجر",
        uploadLogo: "رفع الشعار",
        currentLogo: "الشعار الحالي",
        noLogoUploaded: "لم يتم رفع شعار",

        // Brand Colors
        brandColors: "ألوان العلامة التجارية",
        brandColorsDescription: "خصص نظام الألوان لمتجرك. سيتم تطبيق هذه الألوان على موقعك بالكامل.",
        primaryColor: "اللون الأساسي",
        primaryColorHelp: "لون الموضوع الرئيسي المستخدم للأزرار والروابط والتمييزات",
        hoverColor: "لون التمرير",
        hoverColorHelp: "اللون المعروض عند التمرير فوق العناصر التفاعلية",
        textColor: "لون النص",
        textColorHelp: "لون النص الأساسي للعناوين والمحتوى",
        lightColor: "لون الخلفية الفاتح",
        lightColorHelp: "لون خلفية ناعم للأقسام والبطاقات",

        // Shipping Tab
        selectCurrency: "اختر العملة",
        storeLogo: "شعار المتجر",
        uploadLogo: "تحميل الشعار",
        currentLogo: "الشعار الحالي",
        noLogoUploaded: "لم يتم تحميل شعار",

        // Shipping Tab
        shippingSettings: "إعدادات الشحن",
        shippingRequirement: "الشحن والتوصيل",
        requiresShipping: "هذا المتجر يتطلب شحن/توصيل للمنتجات",
        requiresShippingHelp: "قم بإلغاء التحديد إذا كنت تبيع منتجات رقمية أو دورات أو خدمات لا تتطلب توصيل فعلي. عند التعطيل، لن يحتاج العملاء إلى توفير عناوين الشحن.",
        shippingOptions: "خيارات الشحن",
        editShippingOptionsIn: "تعديل خيارات الشحن بـ:",
        addShippingOption: "إضافة خيار شحن",
        shippingMethodName: "اسم طريقة الشحن",
        cost: "التكلفة",
        deliveryTime: "وقت التسليم",
        freeDeliverySettings: "إعدادات التوصيل المجاني",
        enableFreeDelivery: "تفعيل التوصيل المجاني",
        minimumSpendForFreeDelivery: "الحد الأدنى للإنفاق للتوصيل المجاني",
        noShippingOptionsAdded: "لم يتم إضافة خيارات شحن بعد",

        // Payment Tab
        paymentSettings: "إعدادات الدفع",
        acceptedPaymentMethods: "طرق الدفع المقبولة",
        creditCard: "بطاقة ائتمان",
        paypal: "باي بال",
        applePay: "آبل باي",
        cashOnDelivery: "الدفع عند التسليم",
        manualTransfer: "التحويل البنكي اليدوي",
        bankTransferDetails: "تفاصيل التحويل البنكي",
        bankTransferDetailsNote: "الصق تفاصيل حسابك البنكي هنا. ستُعرض هذه المعلومات للعملاء الذين يختارون الدفع عن طريق التحويل البنكي.",
        bankDetailsEnglish: "التفاصيل البنكية (بالإنجليزية)",
        bankDetailsArabic: "التفاصيل البنكية (بالعربية)",
        savePaymentMethods: "حفظ طرق الدفع",
        paymentMethodsSaved: "تم حفظ طرق الدفع بنجاح!",
        failedToSavePaymentMethods: "فشل في حفظ طرق الدفع",

        // Tax Tab
        taxSettings: "إعدادات الضريبة",
        taxRate: "معدل الضريبة (%)",
        taxIncluded: "الضريبة متضمنة في الأسعار",
        taxExcluded: "الضريبة غير متضمنة في الأسعار",

        // Countries Tab
        countrySettings: "إعدادات البلدان",
        availableCountries: "البلدان المتاحة",
        addCountry: "إضافة بلد",
        countryCode: "رمز البلد",
        countryName: "اسم البلد",
        noCountriesAdded: "لم يتم إضافة بلدان بعد",
        viewCountriesIn: "عرض البلدان بـ:",
        countriesDescription: "اختر البلدان التي تريد شحن منتجاتك إليها. ستكون هذه البلدان متاحة للعملاء أثناء الخروج.",
        selectCountry: "اختر بلداً...",

        // Social Media Tab
        socialMediaSettings: "إعدادات وسائل التواصل الاجتماعي",
        socialMediaLinks: "روابط وسائل التواصل الاجتماعي",
        facebookUrl: "رابط فيسبوك",
        instagramUrl: "رابط إنستغرام",
        twitterUrl: "رابط تويتر",
        tiktokUrl: "رابط تيك توك",

        // Email Configuration Tab
        emailConfiguration: "إعدادات البريد الإلكتروني",
        emailConfigDescription: "تكوين إعدادات SMTP لإرسال تأكيدات الطلبات وإعادة تعيين كلمات المرور والإشعارات.",
        configured: "مُكوَّن",
        usingDefaultConfig: "استخدام التكوين الافتراضي من متغيرات البيئة",
        source: "المصدر",
        emailFrom: "عنوان البريد الإلكتروني (المرسل)",
        emailFromHelp: "سيظهر عنوان البريد الإلكتروني هذا كمرسل لجميع رسائل المتجر الإلكترونية",
        emailPassword: "كلمة مرور البريد الإلكتروني / كلمة مرور التطبيق",
        emailPasswordHelp: "كلمة مرور حساب البريد الإلكتروني أو كلمة مرور خاصة بالتطبيق",
        smtpHost: "خادم SMTP",
        smtpHostHelp: "شائع: smtp.hostinger.com، smtp.gmail.com، smtp.office365.com",
        smtpPort: "منفذ SMTP",
        smtpPortHelp: "شائع: 587 (TLS)، 465 (SSL)، 25 (غير آمن)",
        useSSL: "استخدام SSL/TLS (المنفذ 465)",
        useSSLHelp: "قم بتفعيل هذا إذا كنت تستخدم المنفذ 465. عطّله للمنفذ 587 (STARTTLS)",
        saveEmailConfig: "حفظ إعدادات البريد الإلكتروني",
        testEmailConfig: "اختبار إعدادات البريد الإلكتروني",
        testEmailDescription: "أرسل بريداً إلكترونياً تجريبياً للتحقق من أن التكوين الخاص بك يعمل بشكل صحيح",
        testEmailAddress: "عنوان البريد الإلكتروني التجريبي",
        enterTestEmailPlaceholder: "اتركه فارغاً للإرسال إلى بريد حسابك الإلكتروني",
        sendTestEmail: "إرسال بريد إلكتروني تجريبي",
        sendingTest: "جارٍ الإرسال...",
        testEmailSent: "تم إرسال البريد الإلكتروني التجريبي بنجاح!",
        commonProviders: "مزودو SMTP الشائعون",
        failedToLoadEmailConfig: "فشل في تحميل إعدادات البريد الإلكتروني",
        emailFromAndPasswordRequired: "البريد الإلكتروني وكلمة المرور مطلوبان",
        emailConfigSaved: "تم حفظ إعدادات البريد الإلكتروني بنجاح!",
        failedToSaveEmailConfig: "فشل في حفظ إعدادات البريد الإلكتروني",
        enterTestEmail: "يرجى إدخال عنوان بريد إلكتروني تجريبي",
        failedToSendTestEmail: "فشل في إرسال البريد الإلكتروني التجريبي",

        // Stripe Configuration
        stripeConfiguration: "إعدادات Stripe",
        stripePublishableKey: "المفتاح العام",
        stripePublishableKeyHint: "المفتاح العام الذي يبدأ بـ pk_",
        stripeSecretKey: "المفتاح السري",
        stripeSecretKeyHint: "المفتاح السري الذي يبدأ بـ sk_ (سيتم تشفيره)",
        stripeKeysRequired: "المفتاح العام والمفتاح السري مطلوبان",
        stripeConfigSaved: "تم حفظ إعدادات Stripe بنجاح!",
        failedToSaveStripeConfig: "فشل في حفظ إعدادات Stripe",
        testStripeConfig: "اختبار الإعدادات",
        failedToTestStripeConfig: "فشل في اختبار إعدادات Stripe",
        saveStripeConfig: "حفظ إعدادات Stripe",
        testing: "جارٍ الاختبار...",
        stripeConfiguredInDatabase: "تم تكوين Stripe في قاعدة البيانات",
        stripeUsingEnvironment: "استخدام متغيرات البيئة (يُفضل إعداده في قاعدة البيانات)",
        whereToFindKeys: "أين تجد مفاتيح Stripe الخاصة بك:",
        stripeStep1: "انتقل إلى لوحة تحكم Stripe",
        stripeStep2: "ابحث عن 'API key' في شريط البحث",
        stripeStep3: "سيكون المفتاح العام مرئياً ويبدأ بـ pk_live_",
        stripeStep4: "انقر على 'إنشاء مفتاح سري جديد'",
        stripeStep5: "اختر الخيار الثاني: 'بناء التكامل الخاص بك'",
        stripeStep6: "أكمل إعداد التحقق",
        stripeStep7: "ستحصل على مفتاح سري يبدأ بـ sk_live_",
        stripeSecurityNote: "يتم تشفير المفتاح السري الخاص بك قبل التخزين لضمان الأمان",
        failedToLoadStripeConfig: "فشل في تحميل إعدادات Stripe",
        loading: "جارٍ التحميل...",

        // Promo Codes Tab
        promoCodeSettings: "إعدادات أكواد الخصم",
        enablePromoCodes: "تفعيل أكواد الخصم",
        managePromoCodes: "إدارة أكواد الخصم",
        promoCodesDescription: "إنشاء وإدارة أكواد الخصم لعملائك",
        createNewPromoCode: "إنشاء كود خصم جديد",
        editPromoCode: "تحرير كود الخصم",
        promoCode: "كود الخصم",
        promoCodePlaceholder: "مثال: SAVE20",
        description: "الوصف",
        descriptionPlaceholder: "وصف داخلي لكود الخصم هذا",
        discountType: "نوع الخصم",
        percentage: "نسبة مئوية",
        fixedAmount: "مبلغ ثابت",
        discountValue: "قيمة الخصم",
        minimumOrderAmount: "الحد الأدنى لمبلغ الطلب (اختياري)",
        maximumDiscountAmount: "الحد الأقصى لمبلغ الخصم (اختياري)",
        usageLimit: "حد الاستخدام (اختياري)",
        unlimited: "غير محدود",
        validFrom: "صالح من",
        validUntil: "صالح حتى (اختياري)",
        noExpiry: "بدون انتهاء صلاحية",
        isActive: "نشط",
        activePromoCode: "كود خصم نشط",
        firstTimeOnly: "للعملاء الجدد فقط",
        firstTimeOnlyDescription: "فقط العملاء الذين لم يضعوا طلباً من قبل يمكنهم استخدام هذا الكود",
        applicableProducts: "المنتجات المطبقة (اختياري)",
        applicableCategories: "الفئات المطبقة (اختياري)",
        loadingPromoCodes: "جاري تحميل أكواد الخصم...",
        noPromoCodesFound: "لم يتم العثور على أكواد خصم",
        createFirstPromoCode: "أنشئ أول كود خصم لك لبدء تقديم خصومات للعملاء",
        code: "الكود",
        type: "النوع",
        value: "القيمة",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        created: "تم إنشاؤه",
        actions: "الإجراءات",
        edit: "تحرير",
        delete: "حذف",
        activate: "تفعيل",
        deactivate: "إلغاء تفعيل",
        promoCodeRequired: "كود الخصم مطلوب",
        discountValueMustBeGreaterThanZero: "قيمة الخصم يجب أن تكون أكبر من 0",
        promoCodeUpdatedSuccessfully: "تم تحديث كود الخصم بنجاح",
        promoCodeCreatedSuccessfully: "تم إنشاء كود الخصم بنجاح",
        failedToSavePromoCode: "فشل في حفظ كود الخصم",
        promoCodeDeletedSuccessfully: "تم حذف كود الخصم بنجاح",
        failedToDeletePromoCode: "فشل في حذف كود الخصم",
        failedToUpdatePromoCodeStatus: "فشل في تحديث حالة كود الخصم",
        activated: "مفعّل",
        deactivated: "غير مفعّل",
        promoCodeStatusUpdated: "تم {status} كود الخصم بنجاح",

        // Announcements Tab
        announcementSettings: "إعدادات الإعلانات",
        manageAnnouncements: "إدارة الإعلانات",

        // Home Page Tab
        homePageSettings: "إعدادات الصفحة الرئيسية",
        manageHomePageContent: "إدارة محتوى الصفحة الرئيسية",
        homePageContent: "محتوى الصفحة الرئيسية",
        customizeHomePageDescription: "قم بتخصيص ما يراه عملاؤك في الصفحة الرئيسية لمتجرك",
        editContentIn: "تحرير المحتوى بـ:",
        loadingHomePageContent: "جاري تحميل محتوى الصفحة الرئيسية...",
        heroSection: "القسم الرئيسي",
        heroSectionDescription: "يظهر هذا في أعلى الصفحة الرئيسية كبانر كبير مع نص متراكب. إنه أول شيء يراه العملاء عند زيارة متجرك.",
        mainTitle: "العنوان الرئيسي",
        subtitle: "العنوان الفرعي",
        mainTitlePlaceholder: "مثال: صُنع بأيدٍ إماراتية",
        subtitlePlaceholder: "مثال: مصنوعة بحب، خصيصاً لك",
        displayedAsLargeHeading: "يُعرض كعنوان كبير على البانر الرئيسي",
        appearsUnderMainTitle: "يظهر تحت العنوان الرئيسي",
        heroMediaUpload: "رفع وسائط القسم الرئيسي",
        heroMediaDescription: "اختر صورة أو فيديو مذهل لخلفية القسم الرئيسي",
        currentMedia: "الوسائط الحالية",
        uploadNewMedia: "رفع وسائط جديدة",
        removeMedia: "إزالة الوسائط",
        removeMediaTitle: "إزالة الوسائط",
        heroPreview: "معاينة القسم الرئيسي",
        supportedFormats: "التنسيقات المدعومة: JPG, PNG, GIF, MP4, WebM (الحد الأقصى 10 ميجابايت)",
        overlayOpacity: "شفافية التراكب",
        overlayOpacityDescription: "اضبط تعتيم الخلفية لجعل النص أكثر وضوحاً",
        storySection: "قسم القصة",
        storySectionDescription: "احك قصة علامتك التجارية وتواصل مع العملاء على المستوى الشخصي",
        storyTitle: "عنوان القصة",
        storyDescription: "وصف القصة",
        storyTitlePlaceholder: "مثال: قصتنا",
        storyDescriptionPlaceholder: "شارك رحلة علامتك التجارية أو قيمك أو رسالتك...",
        saveHomePageContent: "حفظ محتوى الصفحة الرئيسية",
        failedToLoadHomePageContent: "فشل في تحميل محتوى الصفحة الرئيسية",
        selectValidImageOrVideo: "يرجى اختيار ملف صورة أو فيديو صالح",
        confirmRemoveMedia: "هل أنت متأكد من أنك تريد إزالة الوسائط الحالية؟ سيتم حفظ هذا عند النقر على \"حفظ محتوى الصفحة الرئيسية\".",
        storeIdRequired: "معرف المتجر مطلوب",

        // Language labels
        english: "الإنجليزية",
        arabic: "العربية",

        // Form validation
        thisFieldIsRequired: "هذا الحقل مطلوب",
        invalidEmailFormat: "تنسيق بريد إلكتروني غير صالح",
        invalidUrlFormat: "تنسيق رابط غير صالح",

        // Common labels
        name: "الاسم",
        description: "الوصف",
        url: "الرابط",
        enabled: "مفعل",
        disabled: "معطل",
        active: "نشط",
        inactive: "غير نشط"
    }
};

// Translation hook for admin settings
export const useAdminSettingsTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = adminSettingsTranslations[language]?.[key] || adminSettingsTranslations['en'][key] || key;

        // Handle string replacements like {message}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};